import styled, { css } from "styled-components";

const Divider = styled.div<{text?: string, spacing?: number}>`
    position: relative;
    text-align: center;
    padding: ${props => props.theme.spacing(props.spacing||0, 0)};

    &:before {
        content: '';
        height: 1px;
        width: 100%;
        background: ${props => props.theme.palette.ui.divider};
        display: block;
        position: absolute;
        top: 50%;
    }
    ${ props => props.text && css`
        &:after {
            content: '${props.text}';
            ${props.theme.typography.body2};
            color: ${props => props.theme.palette.text.disabled};
            background: ${props => props.theme.palette.surface};
            display: inline;
            position: relative;
            padding: 0 8px;
            margin: 0;
        }
    `}
`;

export default Divider;
export { Divider };